// extracted by mini-css-extract-plugin
export default {"list":"Comments_list__X4d-a","item":"Comments_item__etdeB","author":"Comments_author__N3New","comment":"Comments_comment__Yxxms"};